import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';

export const openPremiumPricingModal = (isTrial: boolean, upsellFeatureName?: string): void => {
  const modalId = MODALS_IDS.PREMIUM_PRICING_MODAL;

  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: modalId,
      panelProps: {
        modalId: modalId,
        isTrial: isTrial,
        upsellFeatureName: upsellFeatureName,
      },
    })
  );
};
